/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { Screen, Title } from '../_shared/Screen';
import { PrimaryButton } from '../_shared/PrimaryButton';
// reuse the existing photo-guideline examples from the shared assets
import badPhoto1 from '../../../assets/images/badPhoto1.jpg';
import badPhoto2 from '../../../assets/images/badPhoto2.jpg';
import badPhoto3 from '../../../assets/images/badPhoto3.jpg';
import goodPhoto1 from '../../../assets/images/goodPhoto1.jpg';
import goodPhoto2 from '../../../assets/images/goodPhoto2.png';
import goodPhoto3 from '../../../assets/images/goodPhoto3.png';
import styles from './style.module.scss';

const BAD = [
  { key: 'multipleFaces', src: badPhoto1 },
  { key: 'glasses', src: badPhoto2 },
  { key: 'extraFaces', src: badPhoto3 },
];
const GOOD = [
  { key: 'onlyFace', src: goodPhoto1 },
  { key: 'noGlasses', src: goodPhoto2 },
  { key: 'lookStraight', src: goodPhoto3 },
];

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'view', { page: 'hairstyle-women-photo-rules' });
  }, []);

  const next = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page: 'hairstyle-women-photo-rules' });
    onNext();
  };

  const Card = ({ src, label, kind, imgStyle }: { src: string; label: string; kind: 'bad' | 'good'; imgStyle?: React.CSSProperties }) => (
    <div className={styles.card}>
      <div className={styles.cardImg}><img src={src} alt="" style={imgStyle} /></div>
      <div className={styles.bottomStack}>
        <span className={`${styles.badge} ${kind === 'bad' ? styles.badgeBad : styles.badgeGood}`}>
          {kind === 'bad' ? '✕' : '✓'}
        </span>
        <span className={`${styles.label} ${kind === 'bad' ? styles.labelBad : styles.labelGood}`}>{label}</span>
      </div>
    </div>
  );

  return (
    <Screen
      progress={90}
      hideBack={currentIndex === 0}
      onBack={onPrev}
      footer={
        <div className={styles.footer}>
          <p className={styles.secure}>🔒 {t('hairstyleWomenPhotoRules.secure')}</p>
          <PrimaryButton sticky={false} onClick={next}>{t('hairstyleWomenPhotoRules.continue')}</PrimaryButton>
        </div>
      }
    >
      <Title>{t('hairstyleWomenPhotoRules.title')}</Title>

      <section className={styles.section}>
        <h2 className={styles.secTitle}>{t('hairstyleWomenPhotoRules.notAllowedTitle')}</h2>
        <p className={styles.secDesc}>{t('hairstyleWomenPhotoRules.notAllowedDesc')}</p>
        <div className={styles.row}>
          {BAD.map((c) => <Card key={c.key} src={c.src} label={t(`hairstyleWomenPhotoRules.bad.${c.key}`)} kind="bad" />)}
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.secTitle}>{t('hairstyleWomenPhotoRules.allowedTitle')}</h2>
        <p className={styles.secDesc}>{t('hairstyleWomenPhotoRules.allowedDesc')}</p>
        <div className={styles.row}>
          {GOOD.map((c) => <Card key={c.key} src={c.src} label={t(`hairstyleWomenPhotoRules.good.${c.key}`)} kind="good" imgStyle={(c as any).imgStyle} />)}
        </div>
      </section>
    </Screen>
  );
}

export default Page;
